module.exports = __webpack_public_path__ + "img/productive-time.63d50d78.png";